const config = {
  ENVIRONMENT_NAME: 'testing',
  forwoodId: {
    URL: 'https://id.testing.recovery.forwoodsafety.com',
    USER_TOKEN_URL: 'https://g0xsh3rf90.execute-api.us-west-2.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://nt9d0a8gdl.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.2',
    HOSTNAME: 'https://admin.testing.recovery.forwoodsafety.com',
    COMPANY_MICROFRONTEND_URL: 'https://company.testing.recovery.forwoodsafety.com',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.testing.recovery.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.testing.recovery.forwoodsafety.com',
    WEBSOCKET: 'wss://jlmo7ui728.execute-api.us-west-2.amazonaws.com/testing'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
